import * as Yup from "yup";
import { validatePassword, validateConfirmPassword } from "../common";

export const changePasswordSchema = Yup.object().shape({
  oldPassword: validatePassword,
  password: validatePassword,
  passwordConfirmation: validateConfirmPassword("password"),
});
